import { CSSProperties, ReactNode } from "react";
import { enums } from "../../../shared";
import { useClassNames } from "../../../shared/hooks";

import styles from "./styles.module.scss";
import utilities from "../../../shared/styles/utilities.module.scss";
import { useIntl } from "react-intl";

type TextType = {
  size?: enums.SIZE;
  isBlack?: boolean;
  isBold?: boolean;
  noMargin?: boolean;
  noBottomMargin?: boolean;
  noTopMargin?: boolean;
  textCenter?: boolean;
  children: ReactNode;
  sx?: CSSProperties;
  className?: string;
  alt?: string;
};

const Text = ({
  size = enums.SIZE.MD,
  isBlack,
  isBold,
  noMargin,
  textCenter,
  children,
  sx,
  className,
  noBottomMargin,
  noTopMargin,
  alt,
}: TextType) => {
  const classNames = useClassNames([
    styles.Text,
    size === "xl" ? styles["Text--xl"] : "",
    size === "lg" ? styles["Text--lg"] : "",
    size === "md" ? styles["Text--md"] : "",
    size === "sm" ? styles["Text--sm"] : "",
    size === "xs" ? styles["Text--xs"] : "",
    isBlack ? styles["Text--black"] : "",
    isBold ? styles["Text--bold"] : "",
    noMargin ? styles["Text--rmMargin"] : "",
    noBottomMargin ? styles["Text--rmBMargin"] : "",
    noTopMargin ? styles["Text--rmTMargin"] : "",
    textCenter ? utilities["u-textCenter"] : "",
    className ? className : "",
  ]);

  const intl = useIntl();
  return (
    <span
      style={sx}
      className={classNames}
      title={alt && intl.formatMessage({ id: alt })}
    >
      {children}
    </span>
  );
};

export default Text;
